"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Checkbox"));
var _Label = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Label"));
var _TextField = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TextField"));
var _TextArea = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TextArea"));
var _GrantTypes = _interopRequireDefault(require("../GrantTypes"));
var _OAuthRedirectURIs = _interopRequireDefault(require("../OAuthRedirectURIs"));
var _validations = require("./validations");
var _utils = require("./utils");
var styles = {
  "form-fields": "Fields__form-fields__2j4bh",
  "formFields": "Fields__form-fields__2j4bh",
  "errors": "Fields__errors__3y76s",
  "description": "Fields__description__38CbX"
}; 
require('./Fields.css');
var Fields = function Fields(props) {
  var form = props.form,
    errors = props.errors,
    isConfigurable = props.isConfigurable,
    identityManagementType = props.identityManagementType,
    isGrantTypesDirty = props.isGrantTypesDirty,
    grantTypes = props.grantTypes;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.formFields,
    "data-test-id": "application-form-fields"
  }, errors && errors.length !== 0 ? /*#__PURE__*/_react.default.createElement("div", {
    id: "application-name-describedby",
    role: "alert",
    "aria-live": "assertive",
    className: styles.errors,
    "data-test-id": "application-errors"
  }, errors.map(function (error) {
    return error.message;
  }).join('. ')) : null, /*#__PURE__*/_react.default.createElement(_Label.default, {
    className: "visually-hidden",
    htmlFor: "application-name"
  }, "Application Name"), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    id: "application-name",
    "aria-describedby": "application-name-describedby",
    "aria-invalid": errors && errors.length > 0,
    name: "name",
    label: "Application Name",
    placeholder: "Enter application name",
    required: true,
    value: form.name,
    testId: "application-name"
  }), /*#__PURE__*/_react.default.createElement(_TextArea.default, {
    id: "description",
    name: "description",
    label: "Description",
    className: styles.description,
    placeholder: "Write a description here...",
    value: form.description,
    testId: "application-description"
  }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    label: "Application URL",
    id: "applicationURL",
    name: "applicationURL",
    validate: (0, _validations.urlValidator)(),
    placeholder: "https://yourcompany.com/applicationURL",
    value: form.applicationURL,
    testId: "application-url"
  }), (0, _GrantTypes.default)({
    form: form,
    grantTypes: grantTypes,
    isConfigurable: isConfigurable,
    identityManagementType: identityManagementType,
    isGrantTypesDirty: isGrantTypesDirty
  }), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    label: /*#__PURE__*/_react.default.createElement(_OAuthRedirectURIs.default, null),
    id: "redirectURI",
    name: "redirectURI",
    "aria-describedby": "info-oauth-tooltip-text",
    validate: (0, _validations.redirectURIValidator)(),
    placeholder: "https://yourcompany.com/callback",
    value: form.redirectURI,
    required: (0, _utils.isOauthRedirectURIsRequired)({
      form: form,
      isConfigurable: isConfigurable
    }),
    testId: "application-redirect-uri"
  }), identityManagementType ? /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    key: "apiEndpoints",
    name: "apiEndpoints",
    label: "Automatically register the redirect URIs for API Notebook and API Console",
    value: form.apiEndpoints,
    testId: "apiEndpoints"
  }) : null);
};
var _default = exports.default = Fields;
//# sourceMappingURL=Fields.js.map